const getConfigHash = state => state.configHash;

export default {
  getConfigHash
};
